import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useWindowSize } from '@miro-site/core';
import { useEffect, useState } from 'react';
import { BREAKPOINTS_MEDIAS, medias } from './breakpoints';
export var useCurrentBreakpoint = function useCurrentBreakpoint() {
  var _useState = useState(null),
      currentBreakPoint = _useState[0],
      setCurrentBreakPoint = _useState[1];

  var windowSize = useWindowSize();
  useEffect(function () {
    var _ref = Object.entries(BREAKPOINTS_MEDIAS).find(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          br = _ref4[0];

      return window.matchMedia(medias.on(br)).matches;
    }) || [null],
        _ref2 = _slicedToArray(_ref, 1),
        breakPoint = _ref2[0];

    setCurrentBreakPoint(breakPoint);
  }, [windowSize]);
  return [currentBreakPoint];
};